export default {
  'meta': {
    'langName': 'SLOVENIAN',
    'lang': 'Slovenščina'
  },
  'title': 'ODPOKLIC IZDELKA NASTAVLJIV SAMOSTOJEČI KOŠ S STOJALOM B900 BOX NBA TARMAK',
  'description': 'Ugotovili smo potencialno varnostno tveganje pri samostoječem košarkarskem košu s stojalom B900: med uporabo lahko pride do padca droga, če ročaj za nastavitev višine ni nameščen in se koš premakne.\n\nZaradi svoje varnosti takoj prenehajte z uporabo koša, če nimate nameščenega ročaja za nastavitev višine.\n\nDa bo vaš izdelek popolnoma varen za uporabo, vam bomo zagotovili brezplačen komplet za popravilo z enostavnimi navodili. Spletna stran, ki je trenutno v izdelavi, vas bo vodila skozi vse korake popravila. Obvestili vas bomo takoj, ko bo ta na voljo (predvidoma v juliju).',
  'status': 'Translation validated by COUNTRY'
} as const
